import styled from 'styled-components';

export const SectionWrapper = styled.section`
  padding: 3rem 4rem;
  color: #000 !important;

  .title {
    color: #000 !important;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 3rem;
  }

  h2,
  p {
    line-height: 1.8rem;
    margin-bottom: 1rem;
  }

  p > a,
  li > a {
    text-decoration: underline;
    color: #0f30c5ed;
  }

  .right {
    margin-top: 3rem;
    text-align: right;
  }

  .subTitle {
    margin-top: 3rem;
    font-weight: 600;
    text-indent: 1.5rem;
  }

  .subTitle > .ml-none {
    margin-right: 1rem;
  }

  .subTitle > span {
    margin-right: 2rem;
  }

  ul li {
    list-style-position: inside;
    line-height: 1.8rem;
    padding-left: 2rem;
    margin-bottom: 1rem;
  }

  .indent {
    list-style-position: inside !important;
    padding-left: 5rem;
    list-style: disc;
  }

  ul .styleAlphabetic {
    list-style: lower-latin;
    list-style-position: inside;
    line-height: 1.8rem;
    padding-left: 2rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  table {
    border: 1px solid black;
    margin: 0 auto;
    width: 80%;
    margin-bottom: 3rem;
  }

  table tr,
  table td {
    border: 1px solid black;
  }

  table td ul li {
    margin: 0;
  }

  .table-td-center {
    width: 22rem;

    ul {
      margin-left: 3rem;
    }
  }

  .table-td-top-left {
    display: flex;
    border: none !important;
  }

  .listStyle-none {
    list-style: none;
    text-indent: 1.5rem;
  }

  .listStyle-visible {
    list-style: circle;
    margin-left: 2rem;
  }
`;
